import { IEmployeeExperienceContext } from '@micro-frontend-react/employee-experience/lib/IEmployeeExperienceContext';
import { Context as ReactContext, useContext, useState } from 'react';
import { Context } from '@micro-frontend-react/employee-experience/lib/Context';

export function useCreateRenewalRequest(): [
    (subscriberId: string, environment: number) => Promise<any>,
    boolean,
    string | null
] {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const { httpClient } = useContext(Context as ReactContext<IEmployeeExperienceContext>);

    const createRenewalRequest = async (subscriberId: string, environment: number): Promise<any> => {
        setIsLoading(true);
        setError(null);

        try {
            const response = await httpClient.request({
                url: `${__API_BASE_URL__}/subscriber/renewal-request?subscriberId=${subscriberId}&environment=${environment}`,
                resource: __CLIENT_ID__,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Content-Type-Options': 'nosniff',
                },
            });

            setIsLoading(false);
            return response.data;
        } catch (err: any) {
            setError(err?.response?.data?.message || err?.message || 'Failed to create renewal request.');
            setIsLoading(false);
            throw err;
        }
    };

    return [createRenewalRequest, isLoading, error];
}